import React, { useState } from 'react'
import styles from './projects.module.scss'
import classNames from 'classnames'
import SectionBorder from 'components/Section-Border'
import slidersCards from '../../../../json/db-pt-br.json'
import SwiperSlidersPtBr from './Swiper-pt-br'
import MyModalPtBr from './MyModal-pt-br'


export default function ProjectsPtBr({currentProject, setCurrentProject, darkMode}) {
    const [clickedStates, setClickedStates] = useState(Array(slidersCards.length).fill(false));
    

    const handleImageClick = (index, projectData) => {
        setCurrentProject(projectData);
        const newClickedStates = [...clickedStates];
        newClickedStates[index] = !newClickedStates[index];
        setClickedStates(newClickedStates);
      
        if (currentProject === null) {
            setCurrentProject(projectData);
            document.body.classList.add('overlay');
          }
        };
      
        const handleCloseClick = () => {
          setCurrentProject(null);
          document.body.classList.remove('overlay');
        };

    return (
        <section className={`${styles.project} ${styles.section}`} id='projects'>
            <div className={classNames(styles.main_text, 'scroll_bottom')}>
                <span>Trabalhos Mais Recentes</span>
                <h2>Projetos</h2>
            </div>
            <MyModalPtBr darkMode={darkMode} currentProject={currentProject} />

            {currentProject && (  
        <div className="container_popup">
          <div className="popup">
          <span className='popup_subtitle'>{currentProject.subtitle}</span>
            <h2 className='popup_title'>{currentProject.title}</h2>
            <a className="close" onClick={handleCloseClick} style={{fontSize: '35px', color: '#4d4d4d', cursor: 'pointer'}} >&times;</a>
                <div className="content">
                    <h3 className='popup_Topic'>Sobre o Projeto</h3>
                    <p className='popup_description'>{currentProject.description}</p>
                    
                    <h3 className='popup_Topic'>Tecnologias Usadas</h3>
                            <div className='popup_technologies'>
                            {currentProject.technologies.map((tech) => (
                                <img className='popup_technologies_icons' src={tech.icon} alt={tech.name} key={tech.name} />
                            ))}
                            </div>

                        <h3 className='popup_Topic'>Apresentação do Projeto</h3>
                        <video class="gif-like" autoPlay loop muted playsInline>
                            <source src={currentProject.video} type="video/mp4"/>
                        </video>
                        
                        <h3 className='popup_Topic'>Status do projeto</h3>
                        <p className='popup_status'>{currentProject.status}</p>
                </div>
          </div>
        </div>
      )}
            <div className={styles.container}>
                <div className={classNames(styles.projects_container, 'scroll_scale')}>
                    
                        <SwiperSlidersPtBr currentProject={currentProject} handleImageClick={handleImageClick} clickedStates={clickedStates} />
                    
                </div>
            </div>
            <SectionBorder />
        </section>
    )
}
